
import { defineComponent } from 'vue';
import { app } from '@/libs/app';
import { Table } from 'ant-design-vue';
import './styles.scss';

app.use(Table);

export default defineComponent({
  name: 'Table',
  props: {
    dynamicAttrs: {},
  },
});
